import { BaseDB } from '../dexie/base-db';
import { getNizza } from '../nizza-store';
import { PinoAdapter } from './core/adapters/pino.adapter';
import { ConsoleLogger } from './core/loggers/console';
import { HttpLogger } from './core/loggers/http.logger';
import { LocalStorageLevelService } from './core/services/local-storage-level.service';
import { Logger } from './logger';

export function createNizzaLogger(source: string): Logger {
  const nizza = getNizza();
  return nizza.logger.lazyChild(source);
}

export function createPinoLogger(project: string, db: BaseDB): Logger {
  return Logger.create(
    new PinoAdapter({
      source: project,
      levelService: new LocalStorageLevelService(project),
      consoleLogger: new ConsoleLogger(),
      httpLogger: HttpLogger.create({ db, project }),
    }),
  );
}

export { Logger };
